__turbopack_context__.v({
  "card": "BE4RPW_card",
  "cardSelected": "BE4RPW_cardSelected",
  "icon": "BE4RPW_icon",
  "left": "BE4RPW_left",
});
